/**
 * Created by amir on 2/11/19.
 */

export default class CountdownService {
    static get $inject() {
        return ['$rootScope', '$timeout'];
    }

    constructor($rootScope, $timeout) {
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.setBusy(false);
        this._setExitDelayCounter(null);
    }

    _startCountdown() {
        this.countdown();
    }

    countdown() {

        this.setBusy(true);
        this.stopped = this.$timeout(() => {
            --this.exitDelayCounter;
            this.countdown();

            if (this.getExitDelayCounter() < 1) {
                this.stopArmProcessCountdown();
                this.$rootScope.$broadcast('panelArmedByUser');
            }

        }, 1000);
    }

    stop() {
        this.$timeout.cancel(this.stopped);
        this.stopped = null;
    }

    _setExitDelayCounter(exitDelayCounter) {
        this.exitDelayCounter = exitDelayCounter;
    }

    stopArmProcessCountdown() {

        this.setBusy(false);
        this._setExitDelayCounter(null);
        this.stop();
    }

    setBusy(boolean) {
        this.busy = boolean;
    }

    getExitDelayCounter(){
        return angular.copy(this.exitDelayCounter);
    }
}



/** WEBPACK FOOTER **
 ** ./src/services/app/countdown.service.js
 **/